var _circle, _circle2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFirst = function SvgFirst(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 216 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 126,
    r: 104,
    fill: "currentColor",
    stroke: "url(#paint0_linear_9_13)",
    strokeWidth: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 30,
    r: 27.5,
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.009 20.5455V38H107.318V24.0483H107.216L103.219 26.554V23.2812L107.54 20.5455H111.009Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.65 145.643L96.2893 145.996L96.6464 146.354L110.793 160.5H67.5V151C67.5 147.859 69.0697 145.07 71.7118 142.631C74.3573 140.19 78.0446 138.133 82.1797 136.477C90.4507 133.163 100.388 131.5 107 131.5C108.274 131.5 109.453 131.564 110.884 131.694L96.65 145.643ZM112.704 146L119 139.659L128.996 149.703L129.351 150.059L129.705 149.702L155 124.21L161.296 130.55L129.35 162.79L112.704 146ZM126.5 101C126.5 111.774 117.774 120.5 107 120.5C96.2261 120.5 87.5 111.774 87.5 101C87.5 90.2261 96.2261 81.5 107 81.5C117.774 81.5 126.5 90.2261 126.5 101Z",
    fill: "white",
    stroke: "url(#paint1_linear_9_13)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_13",
    x1: 108,
    y1: 26,
    x2: 108,
    y2: 226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_13",
    x1: 114.5,
    y1: 81,
    x2: 114.5,
    y2: 163.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE",
    stopOpacity: 0.74
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFirst);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/first.f121d143fa7cdb19d60ad066fcd25de1.svg";